import { render } from "./NewsCompany.vue?vue&type=template&id=1ca2a0e7&scoped=true"
import script from "./NewsCompany.vue?vue&type=script&lang=js"
export * from "./NewsCompany.vue?vue&type=script&lang=js"

import "./NewsCompany.vue?vue&type=style&index=0&id=1ca2a0e7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca2a0e7"]])

export default __exports__